/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { StyleSheet } from 'aphrodite';
import { colors } from '@blend/consumer-components';
import { mediaBreakpoints, mediaOrientations } from '../../common/responsive';

export const styles = StyleSheet.create({
  signingRoomPageWrapper: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.clayMinus2,
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: `100%`,
    width: '100%',
    maxWidth: 1440,
    position: 'relative',
    [mediaBreakpoints.mobile]: {
      flexDirection: 'column',
      justifyContent: 'space-between',
      [mediaOrientations.landscape]: {
        flexDirection: 'row-reverse',
      },
    },
  },
  main: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    width: `100%`,
    backgroundColor: colors.snowPlus1,
    [mediaBreakpoints.mobile]: {
      flexDirection: 'column-reverse',
      [mediaOrientations.landscape]: {
        flexDirection: 'row',
      },
    },
  },
  mainWithStrip: {
    [mediaOrientations.portrait]: {
      height: 'auto',
    },
    [mediaOrientations.landscape]: {
      width: 'auto',
    },
  },
  pageLoadingSpinnerHolder: {
    marginTop: '100px',
    textAlign: 'center',
  },
});
